// extracted by mini-css-extract-plugin
export var TextBanner = "TextBanner-module--TextBanner--9tqgY";
export var TextBanner_container = "TextBanner-module--TextBanner_container--YVHJh";
export var TextBanner_img = "TextBanner-module--TextBanner_img--f-CMt";
export var TextBanner_info = "TextBanner-module--TextBanner_info--gclMx";
export var TextBanner_info_text = "TextBanner-module--TextBanner_info_text--RNzJ9";
export var TextBanner_info_title = "TextBanner-module--TextBanner_info_title--9hOpr";